// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Q-tI","content":"GlobalSearch_content__Enl-e"};